import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"

// Login Redux States

//Include Both Helper File with needed methods
import { postJwtForgetPwd, postJwtResetPwd } from "helpers/blopsleads_helper"
import { RESET_PASSWORD } from "./actionTypes"
import { resetUPMessage } from "./actions"

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* resetPassword({ payload: { user, history } }) {
  try {
    console.log("reseting...")
    const response = yield call(postJwtResetPwd, {
      email: user.email,
      password: user.password,
      token: user.token,
    })
    console.log("response", response)
    if (response.status) {
      yield put(resetUPMessage())
      yield delay(3000)
      history.push("/login")
    } else {
      yield put({
        type: "RESET_PASSWORD_FAILURE",
        payload: response.response.data.message || "Erro ao redefinir a senha",
      })
    }
  } catch (error) {
    console.log(error)
    yield put({
      type: "RESET_PASSWORD_FAILURE",
      payload: error.response?.data?.message || "Ocorreu um erro inesperado",
    })
  }
}

export function* watchUserResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword)
}

function* resetPasswordSaga() {
  yield all([fork(watchUserResetPassword)])
}

export default resetPasswordSaga
